import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {VatRate} from "../../../model/customer/vat-rate";
import {CustomerVatRateService} from "../../../services/customer/customer-vat-rate.service";
import TYPE = FormFieldConfig.TYPE;
import {Customer} from "../../../model/customer/customer";

@Component({
  selector: 'app-vat-rate',
  templateUrl: './vat-rate.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class VatRateComponent extends CrudBaseComponent<VatRate> {

  //fields
  countries: FieldRecord<any>[]

  constructor(cdref: ChangeDetectorRef,
              customerVatRateService: CustomerVatRateService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = customerVatRateService;
    this.newRecord = new VatRate();
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'country',
        width: 150,
        // icon: (record: VatRate) => {
        //   const countryField = this.countries.find(field => field.text.toUpperCase() == record.country.toUpperCase());
        //   return countryField ? 'flag-icon flag-icon-' + countryField.id.toLowerCase() : '';
        // },
        icon: (value: Customer) => value.country ? 'flag-icon flag-icon-' + value.country.toLowerCase() : '',
        // mapId: value => ''
        mapId: (record: VatRate) => {
          const countryField = this.countries.find(field => field.id.trim() == record.country.trim());
          return countryField ? countryField.text : '';
        }
      },
      {
        field: 'code',
        width: 150
      },
      {
        field: 'rate',
      },
    ];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'country',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            // optionValue: 'value',
            // icon: id => {
            //   const countryField = this.countries.find(field => field.value.toUpperCase() == id.toUpperCase());
            //   return 'flag-icon flag-icon-'+(countryField?countryField.id.toLowerCase():id.toLowerCase());
            // },
            options: () => this.countries,
            icon: id => id ? ('flag-icon flag-icon-' + id.toLowerCase()) : '',
            changed: event => this.formRecord.country = event.value.toUpperCase()
          },
          {
            field: 'code',
            required: true,
            column: 4,
            type: TYPE.TEXT,
          },
          {
            field: 'rate',
            column: 4,
            type: TYPE.DECIMAL
          },
        ]
      }
    ];
  }

  protected initData() {
    super.initData();

    this.formLoading = true;
    this.commonFieldService.getCountries(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.countries = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.formLoading = false;
    })
  }

}
